/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

jQuery(document).ready(function($) {

	var stickyHeaderWidth = 1200,
		stickyHeaderStart = 200,
		headerOffset      = 100, // Height of sticky header
		menuResizeWidth   = 768;

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$('#header-a #main-menu, #header-b #main-menu, #header-d #main-menu').argonmenu({

		resizeWidth: menuResizeWidth,
		collapserTitle: '',
		animSpeed: 'medium',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;',
		expandIcon: '<span class="sub-collapser"><i class="fas fa-angle-down"></i></span>',
		collapseIcon: '<span class="sub-collapser"><i class="fas fa-angle-up"></i></span>'

	});

	$('#main-menu a[href="#"]').click(function(){

		if ($(window).width() <= menuResizeWidth) {

			$(this).parent().find('> .sub-toggle').click();

		}

		return false;

	});

	$('#header-c .nav-icon').click(function(){

		$('body').toggleClass('nav-open');

	});

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var stickyHeader = $('#header-a, #header-b, #header-c, #header-d');

	function rpjcStickyHeader() {

		var screenSize = $(window).width(),
			scrollTop  = $(document).scrollTop(),
			wrapper    = $('#wrapper');

		if (screenSize < stickyHeaderWidth ) return;

		if ( scrollTop > stickyHeaderStart ) {

			$(stickyHeader).addClass('stuck');
			$(wrapper).addClass('header-stuck');

		} else {

			$(stickyHeader).removeClass('stuck');
			$(wrapper).removeClass('header-stuck');

		}

	}

	rpjcStickyHeader();

	$(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Site Search
	//--------------------------------------------

	$('.toggle-search').click(function() {

		$('body').toggleClass('search-open');

		$('.site-search input[type="text"]').focus();

		return false;

	});

	$('.site-search-close').click(function() {

		$('body').toggleClass('search-open');

		return false;

	});

	//--------------------------------------------
	// Sliders
	//--------------------------------------------

	// Default Sliders

	var defaultSliders = document.querySelectorAll('.default-slider .splide');

	defaultSliders.forEach(slider => {

		new Splide(slider, {

			type: 'loop',
			perPage: 1,
			pauseOnFocus: true

		}).mount();

	});

	// Logo Scrollers

	var logoScrollers = document.querySelectorAll('.logo-scroller .splide');

	logoScrollers.forEach(slider => {

		var logoScroller = new Splide(slider, {

			type: 'loop',
			gap: 20,
			autoplay: true,
			interval: 3000,
			perPage: 5,
			perMove: 1,
			arrows: false,
			pagination: false,
			breakpoints: {
				960: {
					perPage: 4
				},
				768: {
					perPage: 3
				},
				480: {
					perPage: 2
				}
			}

		});

		logoScroller.on('mounted resized', function() {

			if (logoScroller.length <= logoScroller.options.perPage) {

				logoScroller.options.perPage = logoScroller.length;

			}

		});

		logoScroller.mount();

	});

	// Testimonial Scrollers

	var testimonialScrollers = document.querySelectorAll('.section-testimonials .splide');

	testimonialScrollers.forEach(slider => {

		new Splide(slider, {

			type: 'loop',
			perPage: 1,
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 15000,
			speed: 400,
			rewind: true,
			pauseOnFocus: true

		}).mount();

	});

	// Section Sliders

	var sectionSliders = document.querySelectorAll('.section-slider .splide');

	sectionSliders.forEach(slider => {

		new Splide(slider, {

			type: 'fade',
			perPage: 1,
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 5000,
			speed: 2000,
			pauseOnFocus: true

		}).mount();

	});

	// Landing Slider

	var landingSlider = document.querySelector('#landing .splide');

	if (landingSlider) {

		const landingSliderSplide = new Splide(landingSlider, {

			type: 'fade',
			rewind: true,
			perPage: 1,
			autoplay: true,
			interval: 7000,
			speed: 2000,
			arrows: false,
			pagination: true,
			drag: false,
			pauseOnHover: false

		});

		landingSliderSplide.on( 'pagination:updated', function() {

			if ( landingSliderSplide.length === 1 ) {

				$('#landing .splide__pagination').hide();

			} else {

				$('#landing .splide__pagination').show();

			}

		} );

		landingSliderSplide.mount();

	}

	// Logo Scrollers

	var projectSliders = document.querySelectorAll('.projects-slider .splide');

	projectSliders.forEach(slider => {

		var projectSlider = new Splide(slider, {

			type: 'loop',
			gap: 20,
			autoplay: true,
			interval: 3000,
			perPage: 4,
			perMove: 1,
			arrows: true,
			pagination: false,
			breakpoints: {
				960: {
					perPage: 3
				},
				768: {
					perPage: 2
				},
				550: {
					perPage: 1
				}
			}

		});

		projectSlider.on('mounted resized', function() {

			if (projectSlider.length <= projectSlider.options.perPage) {

				projectSlider.options.perPage = projectSlider.length;

			}

		});

		projectSlider.mount();

	});


	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$('.lightbox-image').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.lightbox-image.wp-block-image').magnificPopup({
		delegate: 'a',
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.lightbox-iframe').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'iframe',
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
				'</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: 'https://www.youtube.com/embed/%id%?autoplay=1'
				}
			}
		}
	});

	$('.lightbox-team').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific rpjc-magnific-team',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'ajax',
		fixedContentPos: true,
		callbacks: {
			ajaxContentAdded: function() {
				$('.close-team-lightbox').click(function(e){
					e.preventDefault();
					$.magnificPopup.close();
				});
			}
		}
	});

	$('.lightbox-gallery').each(function(){

		$(this).magnificPopup({
			delegate: 'a',
			closeBtnInside: false,
			mainClass: 'rpjc-magnific',
			closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
			type: 'image',
			closeOnBgClick: false,
			gallery: {
				enabled: true,
				arrowMarkup: '<div title="%title%" class="mfp-arrow mfp-arrow-%dir%"><span></span><span></span></div>'
			}
		});

	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$('.accordion .accordion-content').hide();

	var hash = window.location.hash;

	// Check if there's hash tag in the URL
	if (hash.length) {

		var selectedAccordionItem = $('body').find('.accordion .accordion-item' + hash);

		// If yes, open the matching accordion item
		if (selectedAccordionItem.length) {

			var scrollPx = $(window).width() >= stickyHeaderWidth ? selectedAccordionItem.offset().top - headerOffset : selectedAccordionItem.offset().top;

			selectedAccordionItem.addClass('selected').find('.accordion-content').show();

			// Perform scroll down
			$('html, body').animate({scrollTop: scrollPx},'slow');

		}

	}

	if ("onhashchange" in window) {

		// detect hash url changes
		$( window ).on( 'hashchange', function( e ) {

			//hide open accordion
			$('.accordion-item').removeClass('selected');
			$('.accordion-content').hide();

			var hash = window.location.hash;

			var selectedAccordionItem = $('body').find('.accordion .accordion-item' + hash);

			// If yes, open the matching accordion item
			if (selectedAccordionItem.length) {

				var scrollPx = $(window).width() >= stickyHeaderWidth ? selectedAccordionItem.offset().top - headerOffset : selectedAccordionItem.offset().top;

				selectedAccordionItem.addClass('selected').find('.accordion-content').show();

				// Perform scroll down
				$('html, body').animate({scrollTop: scrollPx},'slow');

			}

		} );

	}


	$('.accordion-handle').click(function(){

		var accordion = $(this).parent().parent();

		if ($('.accordion-content').not(':animated')) {

			if ($(this).parent().hasClass('selected')) {

				$(this).next().slideUp(300).end().parent().removeClass('selected');

			} else {

				$(accordion).find('.accordion-item').removeClass('selected');
				$(this).parent().addClass('selected');
				$(accordion).find('.accordion-content').slideUp(300);

				var activeAccordion = $(this).parent();

				$(this).next().slideDown(300, function(){

					var scrollPx = $(window).width() >= stickyHeaderWidth ? activeAccordion.offset().top - headerOffset : activeAccordion.offset().top;

					// Scroll to selected accordion item in viewport
					$('html, body').animate({scrollTop: scrollPx},'slow');

				});

			}

		}

		return false;

	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	// Check if there's hash tag in the URL
	if (hash.length) {

		var selectedTabPanel = $('body').find('.tabbed-content .tab-window ' + hash);

		// If yes, open the matching tab item
		if (selectedTabPanel.length) {

			var scrollPx = $(window).width() >= stickyHeaderWidth ? selectedTabPanel.offset().top - headerOffset : selectedTabPanel.offset().top;

			$('.tabbed-content .tab-window .tab-panel').hide();
			$('.tabbed-content .tab-nav li a[href="' + hash + '"]').parent().addClass('active');

			selectedTabPanel.show();

			// Perform scroll down
			$('html, body').animate({scrollTop: scrollPx},'slow');

		}

	} else {

		$('.tabbed-content .tab-nav li:first-child').addClass('active');
		$('.tabbed-content .tab-window .tab-panel').not(':first-child').hide();

	}

	$('.tabbed-content .tab-nav a').click(function(){

		var target = $(this).attr('href');

		$(this).parent().addClass('active').siblings().removeClass('active');

		$(target).show().siblings().hide();

		return false;

	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$('.scroll-to').click(function(){

		var selected = $(this).attr('href'),
			scrollPx = ($(window).width() < stickyHeaderWidth) ? $(selected).offset().top - 20 : $(selected).offset().top - headerOffset;

		$('html, body').animate({scrollTop: scrollPx},'slow');

		return false;

	});

	// Scroll to top link

	$('a[href="#top"]').click(function(){

		$('html, body').animate({scrollTop:0}, 'slow');

		return false;

	});

	$('.scrolldown').click(function(){

		var target = $(this).parent().next(),
			distance;

		if ($(window).width() < stickyHeaderWidth) {

			distance = $(target).offset().top;

		} else {

			distance = $(target).offset().top - headerOffset;

		}

		$('html, body').animate({scrollTop: distance},'slow');

		return false;

	});

    //--------------------------------------------
	// Responsive Horizontal Scrolling
	//--------------------------------------------

	$( '.responsive-scroll' ).each( function() {

		var element       = $( this ),
			scrollWrapper = $( '<div />', {

				'class' : 'scrollable',
				'html'  : '<div class="scrollable-inner" />'

			} ).insertBefore( element );

		element.data( 'scrollWrapper', scrollWrapper );
		element.appendTo( scrollWrapper.find( 'div' ) );

		if ( element.outerWidth() > element.parent().outerWidth() ) {

			element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

		}

		$( window ).on( 'resize orientationchange', function() {

			if ( element.outerWidth() > element.parent().outerWidth() ) {

				element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

			} else {

				element.data( 'scrollWrapper' ).removeClass( 'has-scroll' );

			}

		} );

	} );

	//--------------------------------------------
	// fitVids
	//--------------------------------------------

	$('.main').fitVids();

	//--------------------------------------------
	// Read More
	//--------------------------------------------

	$('.read-more-content').hide();

	$('.read-more-button .btn').on('click', function(e){

		e.preventDefault();

		var readMoreButton = $(this),
			moreText       = readMoreButton.attr('data-more'),
			lessText       = readMoreButton.attr('data-less');

		$(readMoreButton).parent().next().not(':animated').slideToggle(300, function(){

			if ($(this).is(':visible')) {

				readMoreButton.html(lessText);

			} else {

				readMoreButton.html(moreText);

			}

		});

	});

	//--------------------------------------------
	// Team B
	//--------------------------------------------

	$( '.team-b .team-link' ).click( function( e ) {

		e.preventDefault();

		var details = $( this ).attr( 'href' ),
			link    = $( this );

		if ( $( link ).hasClass( 'active' ) ) {

			$( details ).hide( 0, function() {

				$( link ).removeClass( 'active' );

			});

		} else {

			$( '.person-details' ).not( details ).hide( 0, function() {

				$( '.team-b .team-link' ).not( link ).removeClass( 'active' );

			} );

			$( link ).addClass( 'active' );

			$( details ).show( 0 );

		}

	} );

	$( '.person-details .close' ).click( function() {

		var parentID = $( this ).parent().attr( 'id' );

		$( this ).parent().hide( 0, function() {

			$( 'a[href="#' + parentID + '"]' ).removeClass( 'active' );

		} );

	} );

	function rpjc_people_layout() {

		if ( $( window ).width() >= 768 ) {

			$( '.person-details' ).each( function() {

				$( this ).appendTo( $( this ).parent( '.row' ) );

			} );

		} else {

			$( '.person-details' ).each( function() {

				var thisID = $( this ).attr( 'id' );

				$( this ).insertAfter( $('a[href="#' + thisID + '"]').parent() );

			} );

		}

	}

	$( window ).on( 'load resize orientationchange', rpjc_people_layout );

});
